import { render } from "./NotFoundComponent.vue?vue&type=template&id=15c8bd1a"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/exception/NotFoundComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15c8bd1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15c8bd1a', __exports__)) {
    api.reload('15c8bd1a', __exports__)
  }
  
  module.hot.accept("./NotFoundComponent.vue?vue&type=template&id=15c8bd1a", () => {
    api.rerender('15c8bd1a', render)
  })

}


export default __exports__